import React from 'react';
import { aboutContent } from '../data/mock';

const About = () => {
  return (
    <section className="section-padding" id="about">
      <div className="container">
        <div className="section-header">
          <p className="section-label">About Us</p>
          <h2 className="section-title">{aboutContent.title}</h2>
          <p className="section-description">{aboutContent.subtitle}</p>
        </div>
        
        <div className="about-text" style={{ maxWidth: '900px' }}>
          {aboutContent.paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
